// Shared BOQ project presentation helpers — the briotime status palette and a
// taxonomy code → label lookup, used by the project selector and the Project
// Details page.

export const BRIOTIME_STATUS_COLOR = {
  active:    '#2e7d32',
  paused:    '#b08300',
  completed: '#1976d2',
  archived:  '#666',
};

export function labelForNode(taxonomy, code) {
  if (!code) return null;
  return taxonomy?.nodes?.find((n) => n.code === code)?.label || code;
}
